(function () {
  const modal = document.currentScript.closest('product-modal')
  if (!modal) return

  const canvas = modal.querySelector('.product-media-modal__content')
  const control = modal.querySelector('[data-pm-zoom]')
  const value = modal.querySelector('[data-pm-zoom-val]')
  const buttons = modal.querySelectorAll('[data-pm-zoom-step]')
  if (!canvas || !control || !value || !buttons.length) return

  const steps = [1, 1.5, 2, 3]
  let i = 0

  function syncControls () {
    value.textContent = Math.round(steps[i] * 100) + '%'
    buttons.forEach(function (b) {
      b.disabled = b.getAttribute('data-pm-zoom-step') === '-' ? i === 0 : i === steps.length - 1
    })
  }

  function zoomTo (next) {
    const width = canvas.scrollWidth || 1
    const height = canvas.scrollHeight || 1
    const centerX = (canvas.scrollLeft + canvas.clientWidth / 2) / width
    const centerY = (canvas.scrollTop + canvas.clientHeight / 2) / height

    i = next
    canvas.style.setProperty('--pm-zoom', steps[i])

    canvas.scrollLeft = centerX * canvas.scrollWidth - canvas.clientWidth / 2
    canvas.scrollTop = centerY * canvas.scrollHeight - canvas.clientHeight / 2
    syncControls()
  }

  function reset () {
    i = 0
    canvas.style.setProperty('--pm-zoom', steps[0])
    syncControls()
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      const step = b.getAttribute('data-pm-zoom-step') === '+' ? 1 : -1
      zoomTo(Math.min(Math.max(i + step, 0), steps.length - 1))
    })
  })

  /* The viewer closes on any mouse pointerup outside the image. */
  control.addEventListener('pointerup', function (e) {
    e.stopPropagation()
  })

  new MutationObserver(function () {
    if (modal.hasAttribute('open') && i !== 0) reset()
  }).observe(modal, { attributes: true, attributeFilter: ['open'] })

  reset()
})()
